import React, { useState, useEffect, useCallback } from 'react'
import { useQuery } from '@apollo/client'
import Modal from 'react-modal'
import GroupSelect from './group-select'
import SectionPicker from './section-picker'
import findProject from '../queries/find-project'
import { equals } from 'ramda'

const className = {
  base: 'modal',
  afterOpen: 'modal-after-open',
  beforeClose: 'modal-before-close',
}

const overlayClassName = {
  base: 'overlay',
  afterOpen: 'overlay-after-open',
  beforeClose: 'overlay-before-close',
}

const SelectSectionsModal = ({
  isOpen,
  onCancel,
  onSave,
  selected,
  projectId,
  appElement,
}) => {
  const [group, setGroup] = useState(null)
  const [liveQuestions, setLiveQuestions] = useState([])
  const { loading, error, data } = useQuery(findProject, {
    variables: { id: projectId },
  })

  useEffect(() => {
    if (selected) {
      const newGroup = selected.map((s) => s.group)[0]
      if (!equals(newGroup, group)) {
        setGroup(newGroup)
      }
    }

    const newLiveQuestions = data?.project?.liveQuestions || []
    setLiveQuestions(newLiveQuestions)
  }, [selected, data])

  const closeModal = useCallback(() => {
    onCancel()
  }, [onCancel])

  const handleGroupSelect = useCallback((group) => {
    setGroup(group)
  }, [])

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      contentLabel="Select Sections Modal"
      className={className}
      overlayClassName={overlayClassName}
      appElement={appElement}
    >
      <a className="close" onClick={closeModal}>
        Cancel
      </a>
      <h2>Pick Group</h2>
      <GroupSelect
        projectId={projectId}
        selected={group}
        onSelect={handleGroupSelect}
      />
      {group && (
        <SectionPicker
          projectId={projectId}
          liveQuestionCount={liveQuestions.length}
          group={group}
          onSave={onSave}
          selected={selected && selected.map((s) => s.id)}
        />
      )}
    </Modal>
  )
}

export default SelectSectionsModal
